import axios from 'axios'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    sdGlobalSearchBaseURL,
} from '../../constants/index'


const initialState = {
    loading: false,
    error: false,
    success: '',
    searchResult: {}
}

export const getSearchResults = createAsyncThunk('searchSlice/getSearchResults', (query) => {
    return axios
        .get(sdGlobalSearchBaseURL +  query )
        // .get("http://10.248.36.240:8080/sandisk/tools/api/globalsearchquery?q=Sandisk%20Flash&locale=en-us&fl=id,title,description&groupBy=grpDocumentType&groupLimit=2&size=10&documentType=products")
        .then(response => response.data)
})




const searchSlice = createSlice({
    name: 'searchSlice',
    initialState,
    reducers: {

        resetSearchPage: (state) => {
            state.searchResult = {};
        }
    },
    extraReducers: builder => {
        builder.addCase(getSearchResults.pending, state => {
            state.loading = true
        })
        builder.addCase(getSearchResults.fulfilled, (state, action) => {
            state.loading = false
            state.searchResult = action.payload;
            // state.error = ''
        })
        builder.addCase(getSearchResults.rejected, (state, action) => {
            state.loading = false
            // state.error = 
        })
       
    }
})

export const { resetSearchPage } = searchSlice.actions
export default searchSlice.reducer
